/**
 * keycode.json 索引与本地化取值。
 *
 * 从 keyMapSettings 拆出，供 factoryKeys 与 keyMapSettings 共用，避免两者循环引用。
 */
import keycodeData from '@/utils/keycode.json'
import { KeyConfig } from '@rapoo/element'
import { parseNumber } from './keyIdentity'
import type { KeycodeLabel } from '../types'

const getOS = () => {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.includes('windows')) return 'windows'
  if (ua.includes('macintosh') || ua.includes('mac os')) return 'macx'
  if (ua.includes('linux')) return 'linux'
  return null
}

export const getLocalizedField = (field: string | KeycodeLabel = '') => {
  if (!field) return ''
  if (typeof field === 'string') return field

  const os = getOS()
  if (os && field[os]) return field[os]!

  return field.standard || ''
}

/**
 * 统一索引 key，便于用 Map 按 type+code 查询。
 */
export const makeLookupKey = (type: number, code: number) => `${type}_${code}`

/**
 * keycode.json 的平铺数组（兜底为空数组，避免运行时空引用）。
 */
const KEYCODE_ITEMS = ((keycodeData as { key_code_default?: { key?: KeyConfig[] } })
  ?.key_code_default?.key ?? []) as KeyConfig[]

/**
 * keycode 元数据索引：`keywords -> KeyConfig`
 */
export const KEYCODE_KEYWORDS_MAP = new Map<string, KeyConfig>()

/**
 * keycode 元数据索引：`type_code -> KeyConfig`。
 */
export const KEYCODE_META_MAP = new Map<string, KeyConfig>()

for (const item of KEYCODE_ITEMS) {
  const type = parseNumber(item.type)
  const code = parseNumber(item.code)
  if (type == null || code == null) continue
  KEYCODE_META_MAP.set(makeLookupKey(type, code), item)
  KEYCODE_KEYWORDS_MAP.set(item.keywords, item)
}

/**
 * 按 type + code 查找 KeyConfig（用于 MT/TGL/DKS 子键回显）。
 */
export const getKeyConfigByTypeCode = (type?: number, code?: number): KeyConfig | undefined => {
  if (type == null || code == null) return undefined
  return KEYCODE_META_MAP.get(makeLookupKey(type, code))
}
